export default function IconX({ className }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M8.7002 3.09961L13.084 8.94531L13.1582 9.04492L13.2402 8.95117L18.3271 3.09961H20.7119L14.3164 10.457L14.2637 10.5176L14.3115 10.582L22.0508 20.9004H15.2998L10.5684 14.5908L10.4941 14.4922L10.4131 14.585L4.92285 20.9004H2.53809L9.33594 13.0801L9.38965 13.0195L9.34082 12.9541L1.94922 3.09961H8.7002ZM5.66992 5.05957L16.1699 19.0596L16.2002 19.0996H18.4502L18.3301 18.9404L7.83008 4.94043L7.7998 4.90039H5.5498L5.66992 5.05957Z" fill="currentColor" stroke="white" strokeWidth="0.2"/>
    </svg>
  );
}
